import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const addSupplyBrandsMutation = gql`mutation addSupplyBrand($supplyBrand: supply_brands_insert_input!){
  insert_supply_brands_one(object: $supplyBrand){
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSupplyBrandService {

  constructor(
    private apollo: Apollo
  ) { }

  addSupplyBrand(supplyBrand: any){
    return this.apollo.use('external').mutate({
      mutation: addSupplyBrandsMutation,
      variables: {
        supplyBrand
      }
    }).pipe(pluck('data', 'insert_supply_brands_one')).toPromise();
  }
}
